import * as React from "react"
import * as Immutable from 'immutable'
import SimpleFormat from "../../../utils/SimpleFormat";

import { RentalAdvert, RentalAdvertTranslation } from "../../../types/types";
import { ActivitiesRentalBooleans } from "../../../advert_detail/booleans";
import ReadMore from "../../shared/advert/ReadMore";
import RentalBooleanList from "./RentalBooleanList";

type Props = {
  advert: RentalAdvert
  translation: RentalAdvertTranslation
}

export default (props: Props) : JSX.Element => {
  const booleans = Immutable.OrderedSet(ActivitiesRentalBooleans()).filter(x => props.advert[x]).toOrderedSet();
  return booleans.count() > 0 || (!!props.translation && props.translation.activities) ?
    <>
      <div className="content-part">
        <h3>
          {I18n.t('rental_adverts.description.activities')}
        </h3>
        <div>
          <div className="description">
            <ReadMore height={180}>
              {!!props.translation && props.translation.activities ?
                <SimpleFormat
                  text={props.translation.activities}
                />
              : <></>}
              <RentalBooleanList
                advert={props.advert}
                booleans={booleans}
              />
            </ReadMore>
          </div>
        </div>
      </div>
      <hr />
    </>
  : <></>
}
